<admin-app-header></admin-app-header>
<div class="container-fluid admyt-page">
    <!-- Header -->
    <div class="row my-3">
        <div class="col-md-8">
            <h2><i class="fa-solid fa-file-lines me-2"></i> Admyt API Logs</h2>
            <p class="text-muted">Real-time view of all Admyt API requests and responses
                <span class="data-source data-source--admyt ms-2"><i class="fa-solid fa-cloud"></i> Admyt</span>
            </p>
        </div>
        <div class="col-md-4 text-end">
            <button class="btn btn-outline-secondary" (click)="markAllAsViewed()" [disabled]="markingAllViewed || unviewedCount === 0">
                <i class="fa-solid fa-spinner fa-spin" *ngIf="markingAllViewed"></i>
                <i class="fa-solid fa-check-double" *ngIf="!markingAllViewed"></i>
                Mark All as Viewed ({{ unviewedCount }})
            </button>
        </div>
    </div>

    <!-- Stats Cards -->
    <div class="admyt-stat-cards" *ngIf="!loading && allLogs.length > 0">
        <div class="admyt-stat-card admyt-stat-card--blue">
            <span class="data-source data-source--admyt"><i class="fa-solid fa-cloud"></i> Admyt</span>
            <div class="admyt-stat-card__icon"><i class="fa-solid fa-file-lines"></i></div>
            <div class="admyt-stat-card__content">
                <span class="admyt-stat-card__label">Showing</span>
                <span class="admyt-stat-card__value">{{ totalItems }}</span>
            </div>
        </div>
        <div class="admyt-stat-card admyt-stat-card--purple">
            <div class="admyt-stat-card__icon"><i class="fa-solid fa-eye-slash"></i></div>
            <div class="admyt-stat-card__content">
                <span class="admyt-stat-card__label">Unviewed</span>
                <span class="admyt-stat-card__value">{{ unviewedCount }}</span>
            </div>
        </div>
        <div class="admyt-stat-card admyt-stat-card--green">
            <div class="admyt-stat-card__icon"><i class="fa-solid fa-check"></i></div>
            <div class="admyt-stat-card__content">
                <span class="admyt-stat-card__label">Successful</span>
                <span class="admyt-stat-card__value">{{ successCount }}</span>
            </div>
        </div>
        <div class="admyt-stat-card admyt-stat-card--red">
            <div class="admyt-stat-card__icon"><i class="fa-solid fa-exclamation-triangle"></i></div>
            <div class="admyt-stat-card__content">
                <span class="admyt-stat-card__label">Errors</span>
                <span class="admyt-stat-card__value">{{ errorCount }}</span>
            </div>
        </div>
        <div class="admyt-stat-card admyt-stat-card--teal">
            <div class="admyt-stat-card__icon"><i class="fa-solid fa-clock"></i></div>
            <div class="admyt-stat-card__content">
                <span class="admyt-stat-card__label">Avg Duration</span>
                <span class="admyt-stat-card__value">{{ getAverageDuration() }}</span>
            </div>
        </div>
    </div>

    <!-- Filters -->
    <div class="admyt-card">
        <div class="row g-3">
            <div class="col-md-3">
                <label class="form-label">Viewed</label>
                <select class="form-select" [(ngModel)]="viewedFilter" (change)="onFilterChange()">
                    <option value="unviewed">Unviewed Only</option>
                    <option value="viewed">Viewed Only</option>
                    <option value="all">All</option>
                </select>
            </div>
            <div class="col-md-3">
                <label class="form-label">Status</label>
                <select class="form-select" [(ngModel)]="errorFilter" (change)="onFilterChange()">
                    <option value="all">All</option>
                    <option value="errors">Errors Only</option>
                    <option value="success">Success Only</option>
                </select>
            </div>
            <div class="col-md-6">
                <label class="form-label">Endpoint Filter</label>
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Filter by endpoint (e.g., /tenants, /users)" [(ngModel)]="endpointFilter" (input)="onFilterChange()" />
                </div>
            </div>
        </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="text-center my-5">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <p class="mt-2">Loading API logs...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error" class="alert alert-danger">{{ error }}</div>

    <!-- Empty state -->
    <div *ngIf="!loading && !error && filteredLogs.length === 0" class="text-center my-5">
        <i class="fa-solid fa-file-lines fa-3x text-muted"></i>
        <p class="mt-2 text-muted" *ngIf="viewedFilter === 'unviewed'">No unviewed logs. Switch to "All" to see everything.</p>
        <p class="mt-2 text-muted" *ngIf="viewedFilter !== 'unviewed'">No API logs found matching your criteria.</p>
    </div>

    <!-- Logs table -->
    <div *ngIf="!loading && !error && filteredLogs.length > 0" class="admyt-card p-0">
        <div class="table-responsive">
            <table class="admyt-table">
                <thead>
                    <tr>
                        <th style="width: 36px;"></th>
                        <th style="width: 36px;"></th>
                        <th>Timestamp</th>
                        <th>Severity</th>
                        <th>Method</th>
                        <th>Endpoint</th>
                        <th>Status</th>
                        <th>Duration</th>
                        <th>Context</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let log of paginatedLogs; trackBy: trackByLogId">
                        <tr [class.table-danger]="log.isError" [class.opacity-50]="log.viewed" class="cursor-pointer" (click)="toggleExpand(log.$key)">
                            <td class="text-center">
                                <i class="fa-solid" [class.fa-chevron-right]="!isExpanded(log.$key)" [class.fa-chevron-down]="isExpanded(log.$key)"></i>
                            </td>
                            <td class="text-center">
                                <i class="fa-solid fa-circle" [class.text-primary]="!log.viewed" [class.text-muted]="log.viewed" style="font-size: 0.5rem" [title]="log.viewed ? 'Viewed' : 'Unviewed'"></i>
                            </td>
                            <td><small>{{ formatTimestamp(log.timestamp) }}</small></td>
                            <td>
                                <span [class]="getSeverityClass(log)">
                                    <i class="fa-solid" [class.fa-check]="getSeverity(log) === 'success'" [class.fa-exclamation]="getSeverity(log) === 'warning'" [class.fa-times]="getSeverity(log) === 'error'"></i>
                                    {{ getSeverity(log) | titlecase }}
                                </span>
                            </td>
                            <td><span [class]="getMethodBadgeClass(log.method)">{{ log.method }}</span></td>
                            <td><code [title]="log.endpoint">{{ truncateEndpoint(log.endpoint) }}</code></td>
                            <td><span [class]="getStatusBadgeClass(log.responseStatus, log.isError)">{{ log.responseStatus || 'N/A' }}</span></td>
                            <td><small>{{ formatDuration(log.durationMs) }}</small></td>
                            <td>
                                <div class="d-flex gap-1 flex-wrap">
                                    <a *ngIf="log.centreId" [routerLink]="['/admin/admyt-center', log.centreId]" class="admyt-link" (click)="$event.stopPropagation()" title="View Admyt Center"><i class="fa-solid fa-building"></i></a>
                                    <a *ngIf="log.subscriptionId" [routerLink]="['/admin/subscription', log.subscriptionId]" class="admyt-link" (click)="$event.stopPropagation()" title="View Subscription"><i class="fa-solid fa-file-signature"></i></a>
                                    <a *ngIf="log.clientId" [routerLink]="['/admin/client', log.clientId]" class="admyt-link" (click)="$event.stopPropagation()" title="View Client"><i class="fa-solid fa-user"></i></a>
                                </div>
                            </td>
                        </tr>

                        <!-- Expanded details row -->
                        <tr *ngIf="isExpanded(log.$key)" class="bg-light">
                            <td colspan="9" class="p-3">
                                <div class="d-flex justify-content-end mb-2">
                                    <button class="btn btn-sm" [class.btn-outline-secondary]="log.viewed" [class.btn-outline-primary]="!log.viewed" (click)="toggleViewed(log); $event.stopPropagation()">
                                        <i class="fa-solid" [class.fa-eye-slash]="log.viewed" [class.fa-eye]="!log.viewed"></i>
                                        {{ log.viewed ? 'Mark Unviewed' : 'Mark Viewed' }}
                                    </button>
                                </div>
                                <div class="row">
                                    <div *ngIf="log.errorMessage" class="col-12 mb-3">
                                        <div class="alert alert-danger mb-0">
                                            <strong><i class="fa-solid fa-exclamation-triangle"></i> Error:</strong> {{ log.errorMessage }}
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="mb-0"><i class="fa-solid fa-arrow-up text-primary"></i> Request Body</h6>
                                            <button class="btn btn-outline-secondary btn-sm" (click)="copyToClipboard(log.requestBody, 'Request'); $event.stopPropagation()"><i class="fa-solid fa-copy"></i> Copy</button>
                                        </div>
                                        <pre class="bg-dark text-light p-2 rounded" style="max-height: 300px; overflow: auto; font-size: 12px;">{{ formatJson(log.requestBody) }}</pre>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="d-flex justify-content-between align-items-center mb-2">
                                            <h6 class="mb-0"><i class="fa-solid fa-arrow-down text-success"></i> Response Body</h6>
                                            <button class="btn btn-outline-secondary btn-sm" (click)="copyToClipboard(log.responseBody, 'Response'); $event.stopPropagation()"><i class="fa-solid fa-copy"></i> Copy</button>
                                        </div>
                                        <pre class="bg-dark text-light p-2 rounded" style="max-height: 300px; overflow: auto; font-size: 12px;">{{ formatJson(log.responseBody) }}</pre>
                                    </div>
                                    <div class="col-12 mt-3">
                                        <h6><i class="fa-solid fa-info-circle"></i> Metadata & Links</h6>
                                        <dl class="row mb-0">
                                            <dt class="col-sm-2">Log ID:</dt>
                                            <dd class="col-sm-4"><code>{{ log.$key }}</code></dd>
                                            <dt class="col-sm-2">Full Endpoint:</dt>
                                            <dd class="col-sm-4"><code>{{ log.endpoint }}</code></dd>
                                            <dt class="col-sm-2" *ngIf="log.centreId">Centre:</dt>
                                            <dd class="col-sm-4" *ngIf="log.centreId">
                                                <a [routerLink]="['/admin/admyt-center', log.centreId]" class="admyt-link" (click)="$event.stopPropagation()"><i class="fa-solid fa-building"></i> {{ log.centreId }}</a>
                                            </dd>
                                            <dt class="col-sm-2" *ngIf="log.tenantId">Tenant:</dt>
                                            <dd class="col-sm-4" *ngIf="log.tenantId"><code>{{ log.tenantId }}</code></dd>
                                            <dt class="col-sm-2" *ngIf="log.subscriptionId">Subscription:</dt>
                                            <dd class="col-sm-4" *ngIf="log.subscriptionId">
                                                <a [routerLink]="['/admin/subscription', log.subscriptionId]" class="admyt-link" (click)="$event.stopPropagation()"><i class="fa-solid fa-file-signature"></i> {{ log.subscriptionId }}</a>
                                            </dd>
                                            <dt class="col-sm-2" *ngIf="log.clientId">Client:</dt>
                                            <dd class="col-sm-4" *ngIf="log.clientId">
                                                <a [routerLink]="['/admin/client', log.clientId]" class="admyt-link" (click)="$event.stopPropagation()"><i class="fa-solid fa-user"></i> {{ log.clientId }}</a>
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="p-3 border-top" *ngIf="totalPages > 1">
            <nav aria-label="Log pagination">
                <ul class="pagination justify-content-center mb-0">
                    <li class="page-item" [class.disabled]="currentPage === 1"><a class="page-link" (click)="goToPage(1)"><i class="fa-solid fa-angles-left"></i></a></li>
                    <li class="page-item" [class.disabled]="currentPage === 1"><a class="page-link" (click)="goToPage(currentPage - 1)"><i class="fa-solid fa-chevron-left"></i></a></li>
                    <li *ngFor="let page of getPageNumbers()" class="page-item" [class.active]="page === currentPage"><a class="page-link" (click)="goToPage(page)">{{ page }}</a></li>
                    <li class="page-item" [class.disabled]="currentPage === totalPages"><a class="page-link" (click)="goToPage(currentPage + 1)"><i class="fa-solid fa-chevron-right"></i></a></li>
                    <li class="page-item" [class.disabled]="currentPage === totalPages"><a class="page-link" (click)="goToPage(totalPages)"><i class="fa-solid fa-angles-right"></i></a></li>
                </ul>
            </nav>
            <div class="text-center mt-2">
                <small class="text-muted">Showing {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }} logs</small>
            </div>
        </div>
    </div>
</div>
